import React, { Component } from 'react';

class ErrorBlock extends Component {
  render() {
    return <p className="error-block">{this.props.error ? this.props.error : ''}</p>;
  }
}

export default ErrorBlock;



// WEBPACK FOOTER //
// ./src/components/errorBlock.js